import React, { useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";

import styled from "styled-components";

const ArtistsContainer = styled.div`
  align-self: flex-start;
  width: 100%;

  // margin: 1em 0;

  // @media (max-width: 900px) {
  //   margin: 40px 0;
  // }

  // & h1 {
  //   margin: 0 0 1em 0;
  // }

  & ol {
    margin: 1em 0;
  }

  & .single-artist {
    & p {
      margin: 0;

      & .active-artist {
        opacity: 0;
        visibility: hidden;
        transition: 250ms opacity ease;
      }
    }

    & a.active {
      & p {
        & .active-artist {
          opacity: 1;
          visibility: visible;
        }
      }
    }

    &:hover {
      & .active-artist {
        opacity: 1;
        visibility: visible;
      }
    }

    & a {
      transition: 150ms color ease;

      &:hover {
        color: #6f6d6d;
      }
    }
  }
`;

export const Artists = () => {
  const data = useStaticQuery(graphql`
    {
      allPrismicArtist(sort: { fields: data___title___text, order: ASC }) {
        edges {
          node {
            url
            id
            data {
              title {
                text
              }
            }
          }
        }
      }
    }
  `);

  const splitArtistName = (text) => {
    const name = (text || "").trim();
    const lastSpace = name.lastIndexOf(" ");

    if (lastSpace === -1) {
      return { given: "", surname: name };
    }

    return {
      given: name.slice(0, lastSpace),
      surname: name.slice(lastSpace + 1),
    };
  };

  const sortedByNames = data.allPrismicArtist.edges.slice().sort((a, b) => {
    const aName = splitArtistName(a.node.data.title.text);
    const bName = splitArtistName(b.node.data.title.text);
    const surnameCompare = aName.surname.localeCompare(bName.surname);

    if (surnameCompare !== 0) return surnameCompare;
    return aName.given.localeCompare(bName.given);
  });

  const artistList = sortedByNames.map((artist, index) => (
    <li key={artist.node.id} className="single-artist">
      <Link to={artist.node.url} activeClassName="active">
        <p>
          – {artist.node.data.title.text}{" "}
          <span className="active-artist"> ←</span>
        </p>
      </Link>
    </li>
  ));

  return (
    <ArtistsContainer>
      <ol>{artistList}</ol>
    </ArtistsContainer>
  );
};
